module.exports = __webpack_public_path__ + "img/prize-02.8f2267b5.jpg";